export const SAVE_FIRST_FORM = "SAVE_FIRST_FORM";
export const CLEAR_FIRST_FORM = "CLEAR_FIRST_FORM";

export const SAVE_USER_AND_THERAPIST_ID = "SAVE_USER_AND_THERAPIST_ID";
export const CLEAR_USER_AND_THERAPIST_ID = "CLEAR_USER_AND_THERAPIST_ID";
